import { PlateCategoryMetaInfo, TransactionType } from "@dataModels/ProductModels";
import get from 'lodash/get'

export const calculateDefaultPrice = (metaInfo: PlateCategoryMetaInfo, transactionType: TransactionType) =>{
        const price = get(metaInfo?.startingPrice, transactionType?.code);
        return price;
    }
